export const specialNames = {
  MANAGER: "Manager",
  EMPLOYEE: "Employee",
  ADMIN: "Admin",
};
